
import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const ProductsPage = lazy(() => import('../pages/products/page'));
const ProductDetailPage = lazy(() => import('../pages/product-detail/page'));
const EventsPage = lazy(() => import('../pages/events/page'));
const EventDetailPage = lazy(() => import('../pages/event-detail/page'));
const ArticlesPage = lazy(() => import('../pages/articles/page'));
const ArticleDetailPage = lazy(() => import('../pages/article-detail/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const AppDownloadPage = lazy(() => import('../pages/app-download/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/products',
    element: <ProductsPage />,
  },
  {
    path: '/product/:id',
    element: <ProductDetailPage />,
  },
  {
    path: '/events',
    element: <EventsPage />,
  },
  {
    path: '/event/:id',
    element: <EventDetailPage />,
  },
  {
    path: '/articles',
    element: <ArticlesPage />,
  },
  {
    path: '/article/:id',
    element: <ArticleDetailPage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/app-download',
    element: <AppDownloadPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
